import { base } from '$app/paths';

export function replaceLocaleInUrl(url: URL, locale: string, full = false): string {
  const [, , ...rest] = getPathnameWithoutBase(url).split('/');
  const newPathName = `/${[locale, ...rest].join('/')}`;
  if (!full) {
    return `${newPathName}${url.search}`;
  }

  const newUrl = new URL(url.toString());
  newUrl.pathname = base + newPathName;
  return newUrl.toString();
}

const REGEX_START_WITH_BASE = new RegExp(`^${base}`);

export function getPathnameWithoutBase(url: URL) {
  return url.pathname.replace(REGEX_START_WITH_BASE, '');
}
